
/* eslint-disable react/prop-types */
import { Container, Grid, Stack, styled } from "@mui/material";
import AppSection from "../../components/AppSection";
import { GoogleBannerAds, GoogleGridAds } from "../../components/GoogleAds";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import useLocales from "../../hooks/useLocales";
import useResponsive from "../../hooks/useResponsive";
import useSettings from "../../hooks/useSettings";
import { PATH_THIGPLX } from "../../routes/paths";
import MenuSection from "./MenuSection";
import VideoSection from "./VideoSection";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

export function PracticalSection({ nextItem, prevItem, currentItem, licenseType }) {
  const { themeStretch } = useSettings();
  const { translate } = useLocales();
  const isDesktop = useResponsive('up', 'md');

  const breadcrumbLinks = [
    { name: translate('menu.home'), href: PATH_THIGPLX.home },
    { name: translate('menu.practicalExam'), href: PATH_THIGPLX.practicalExam },
    { name: licenseType.title, href: `/thi-sa-hinh/${licenseType.slug}` },
    { name: currentItem?.title }
  ];

  return (
    <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
      <RootStyle>
        <Grid container>
          <Stack direction={"row"} alignItems={"center"} >
            <HeaderBreadcrumbs
              heading={licenseType.title}
              links={breadcrumbLinks}
              subtitle={currentItem?.title}
            />
          </Stack>
        </Grid>
        <Grid container my={3} >
          <Grid item xs={12} md={3}>
            <MenuSection licenseType={licenseType} />
            <AppSection />
            {isDesktop && <Stack p={1} spacing={2}>
              <GoogleBannerAds />
              <GoogleBannerAds />
            </Stack>}
          </Grid>
          <Grid item xs={12} md={9}>
            <VideoSection currentItem={currentItem} prevItem={prevItem} nextItem={nextItem} licenseType={licenseType} />
          </Grid>
        </Grid>
        <Grid container my={3} >
          <Grid item xs={12} md={12}>
            <GoogleGridAds />
          </Grid>
        </Grid>
      </RootStyle>
    </Container>);
}